export const VERSION_NAME = "beta version 0.0.3";

export const MY_EMAIL = "james@genshin-planner.io";
export const CONTACT_EMAIL = "contact@genshin-planner.io";
export const PROFESSIONAL_EMAIL = "james@james-zhao.com";
